import { FieldDef } from '.'
import { uuid } from '../uuid'
import { GridDef } from '../layouts'
import { Rule } from '../rule'
import { DependOnOption, DisabledType } from '../common'

export class TableDef {
  key?: string = uuid()
  type: 'table' = 'table'
  model!: string
  label?: string
  dependOn?: DependOnOption
  controls: Array<GridDef | FieldDef> = []
  options?: TableOptions = new TableOptions()
  rules?: Rule[]
}

export class TableOptions {
  defaultValue?: any[] = []
  disabled?: DisabledType = false
  limit?: number
  min?: number
}
